var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetherland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flag 2",
    clipPath: "url(#clip0_1664_7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1664_7",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3980",
    d: "M17.4355 9.00112C17.4355 11.2392 16.5465 13.3856 14.9639 14.9681C13.3814 16.5507 11.235 17.4397 8.99691 17.4397C6.75885 17.4397 4.61245 16.5507 3.02991 14.9681C1.44736 13.3856 0.558289 11.2392 0.558289 9.00112C0.558289 6.76306 1.44736 4.61667 3.02991 3.03412C4.61245 1.45157 6.75885 0.5625 8.99691 0.5625C11.235 0.5625 13.3814 1.45157 14.9639 3.03412C16.5465 4.61667 17.4355 6.76306 17.4355 9.00112Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1664_7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3220",
    d: "M17.4375 17.4375V11.8125H0.5625V17.4375H17.4375Z",
    fill: "#2B4896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3990",
    d: "M17.4375 11.8125V6.1875H0.5625V11.8125H17.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3992",
    d: "M17.4375 6.1875V0.5625H0.5625V6.1875H17.4375Z",
    fill: "#C0392B"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1664_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherland);
export default __webpack_public_path__ + "static/media/netherland.457cb6d8448729800662e63dd9da5f17.svg";
export { ForwardRef as ReactComponent };